<template lang="pug">
  .profile-page__main
    .profile-page__header
      .profile-page__title
        h1.title {{ title }}
    .profile-page__body
      .manager-camp
        .manager-camp__tabs
          tab-nav(
          :tab-nav-data="tabs"
          :nameMode="true"
          )
        .manager-camp__main
          router-view(
          :shift-data="shiftData"
          :houses="houses"
          @on-save-shift="onSaveShift"
          :other-shifts="otherShifts"
          )
</template>

<script>

import {mapState, mapActions} from "vuex";
import TabNav from "../../../../../components/tabNav/TabNav";
export default {
  name: "ManagerShiftEditor",
  components: {TabNav},
  data() {
    return {
      shiftData: null,
      shifts: [],
      houses: [],
      errors: {}
    };
  },
  computed: {
    ...mapState([
      "userData",
      "managerShifts"
    ]),
    otherShifts() {
      let otherShifts = [];
      if (this.managerShifts) {
        let shifts = [];
        if (this.shiftData) {
          shifts = this.managerShifts.filter(item => {
            return item.id !== this.shiftData.id;
          });
        } else {
          shifts = this.managerShifts;
        }
        otherShifts = shifts.map(item => {
          return {
            name: item.name,
            id: item.id
          };
        });
      }
      return otherShifts;
    },
    mode() {
      if (this.$route.params.id === "create") {
        return "create";
      }
      return "edit";
    },
    shiftId() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }
      return null;
    },
    title() {
      if (this.mode === "edit") {
        return "Редактирование смены";
      }
      return "Создание смены";
    },
    tabs() {
      const tabs = [
        {
          text: "Общая информация",
          name: "ManagerShiftEditorGeneral"
        },
        {
          text: "Квоты",
          name: "ManagerShiftEditorQuotas"
        },
        {
          text: "Программа",
          name: "ManagerShiftEditorProgram"
        },
        {
          text: "Распорядок дня",
          name: "ManagerShiftEditorSchedule"
        },
        {
          text: "Педагоги",
          name: "ManagerShiftEditorTeachers"
        },
        {
          text: "Контакты",
          name: "ManagerShiftEditorContacts"
        }
      ];
      if (this.mode === "edit") {
        return tabs;
      }
      tabs.length = 1;
      return tabs;
    }
  },
  methods: {
    ...mapActions([
      "getShift",
      "getShifts",
      "createShift",
      "updateShift",
      "getHouses"
    ]),
    onSaveShift(data) {
      if (this.mode === "edit") {
        this.updateShift({
          id: this.shiftId,
          data: data
        }).then(res => {
          if (res.status === 200) {
            this.shiftData = res.data;
            this.$root.$emit("onShowNotificationModal", {
              text:
                "Смена обновлена"
            });
          } else {
            this.$root.$emit("onShowErrorModal", {
              text: `${res.status} ошибка`
            });
          }
        });
      } else if (this.mode === "create") {
        this.createShift(data).then(res => {
          if (res.status === 201) {
            this.shiftData = res.data;
            this.$root.$emit("onShowNotificationModal", {
              text:
                "Смена создана"
            });
            this.$router.push({name: "ManagerShiftEditor", params: {id: this.shiftData.id}});
          } else {
            this.$root.$emit("onShowErrorModal", {
              text: `${res.status} ошибка`
            });
          }
        });
      }
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    if (!this.managerShifts) {
      this.getShifts();
    }

    if (this.mode === "edit") {
      this.getShift(this.shiftId).then(res => {
        this.shiftData = res;
        this.getHouses({
          params: {
            camp: this.shiftData.camp.id
          }
        }).then(res => {
          this.houses = res;
          this.$root.$emit("on-hide-preloader");
        });
      });
    } else {
      this.$root.$emit("on-hide-preloader");
    }
  },
  watch: {
    mode(mode) {
      if (mode === "edit") {
        this.getHouses({
          params: {
            camp: this.shiftData.camp.id
          }
        }).then(res => {
          this.houses = res;
        });
      }
    }
  }
};
</script>
